export default __webpack_public_path__ + "static/media/medical.11aad58b.png";